// The price a comp is shown at. Four screens spelled this out inline —
// `comp.status !== 'Sold' ? comp.price : comp.sold_price` — in the comp table, the map glyph, the
// map's info window and the listing detail page. The ARV screen's own Price filter did not: it
// measured `c.price` for every status, so a Sold comp displaying its sale price was filtered on its
// list price instead. Set the filter to 250 and a comp showing $265,000 could vanish because it was
// listed at $240,000, with nothing on screen explaining it. One function so the number the user
// filters by is the number the user sees.
//
// Not a spec line: files/sow2/spec/arv.md section 4 names the filter "Price (000s)" with defaults
// 250 - Max and says nothing about which field it reads. mr-02 owns the filter row and can decide
// otherwise; what it must not do is go back to two different answers on one screen.
export const compDisplayPrice = (comp) =>
  comp?.status !== 'Sold' ? comp?.price : comp?.sold_price
